import RegulationTypeRepository from '@/shared/http/repositories/configuration/regulationtype'
import { mutationTypes as mutation } from './mutations'
import store from '@/store/'

const MODULE_NAME = 'regulationtype/regulationtypes'
const GET_ALL_BY_AREA = 'getAllRegulationTypeByArea'

export const actionTypes = {
  GET_ALL_BY_AREA
}

export const actions = {

  async [GET_ALL_BY_AREA] ({ commit }, mnemonic, forceReload) {
    if (store.getters[MODULE_NAME].length === 0 || (forceReload)) {
      RegulationTypeRepository.GetAllByAreaMnemonic(mnemonic)
        .then((res) => {
          commit(mutation.SET_REGULATIONTYPES, res.data)
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/module/regulationtype/actions.js